module.exports = __webpack_public_path__ + "img/pic_180160.7028206c.jpg";